import React, { useRef, useEffect } from 'react';
import { injectedComponent } from '@base/core';

export default injectedComponent(
  {
    name: 'ModalDialog',
    styles: ['self'],
  },
  function ModalDialog({ children, onClose, styles: { self: selfStyles } }) {
    const modalRef = useRef();
    const downTarget = useRef(null);

    const handleDialogClick = (e) => {
      e.stopPropagation();
      return false;
    };

    useEffect(() => {
      modalRef.current.scrollTop = modalRef.current.scrollHeight;
    }, []);

    const handleMouseDown = (e) => {
      downTarget.current = e.target;
    };

    const handleMouseUp = (e) => {
      if (e.target === modalRef.current && downTarget.current === modalRef.current) onClose?.();
      downTarget.current = null;
    };

    return (
      <div className={selfStyles.modalContainer}>
        <div
          id="modal"
          className={selfStyles.modal}
          ref={modalRef}
          onMouseDown={handleMouseDown}
          onMouseUp={handleMouseUp}
        >
          <div id="modal-window" className={selfStyles.modalWindow} onClick={handleDialogClick}>
            {children}
          </div>
          {onClose && (
            <div className={selfStyles.closeBtn} onClick={onClose}>
              <div className={selfStyles.closeBtnLine}></div>
            </div>  
          )}
        </div>
      </div>
    );
  }
);